import { HttpService } from "@src/api/common/HttpService";
import { UrlService } from "@src/api/common/UrlService";
import { CookieService } from "@src/api/common/CookieService";

const IeeApiUrl = CookieService.GetCookie("baseUrl");//'https://crdp-api-test.optum.com'

type IdType = {
  id: number;
};

export const AdminClientService = () => {
  const { HttpGet, HttpPost } = HttpService();

 const GetAdminClientList = async (query: string) => {
    const url = `${IeeApiUrl}/api/v3/table/client${query}`;
    const response = await HttpGet(url);
    return response;
  };

  const GetClientById = async (body: IdType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${IeeApiUrl}/api/v3/table/client/detail${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

  const CreateOrUpdateClientById = async (body: any) => {
    const url = `${IeeApiUrl}/api/v3/table/client/detail`;
    const response = await HttpPost(url, body);
    return response;
  };

   return {
    GetAdminClientList,
    GetClientById,
    CreateOrUpdateClientById,
  };
};
